"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceSm, SpaceXs, SpaceMd } from "@nxt-costco-com/forge-design-tokens";
const StyledCompactContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    gap: ${SpaceSm};
    width: 100%;
    height: fit-content;
`;
const StyledDefaultContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: fit-content;
    height: fit-content;
`;
const CheckboxFieldset = styled("fieldset")({
  border: "none",
  margin: "0px",
  padding: "0px"
});
const listSx = {
  "& > li": {
    breakInside: "avoid",
    display: "inline-block",
    marginBottom: SpaceMd,
    width: "100%"
  },
  columnCount: 2,
  columnGap: SpaceMd,
  marginBlockEnd: SpaceXs,
  marginTop: SpaceSm,
  maxWidth: "352px",
  width: "100%"
};
const buttonIconSx = {
  ":focus": {
    borderRadius: "0",
    outline: "2px auto -webkit-focus-ring-color"
  }
};
export {
  CheckboxFieldset,
  StyledCompactContainer,
  StyledDefaultContainer,
  buttonIconSx,
  listSx
};
